// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width: 767px) {\n  .home {\n    flex-direction: column;\n    overflow: initial;\n  }\n}", "",{"version":3,"sources":["webpack://./src/pages/common/index.scss"],"names":[],"mappings":"AAAA;EACE;IACE,sBAAA;IACA,iBAAA;EACF;AACF","sourcesContent":["@media only screen and (max-width: 767px) {\n  .home {\n    flex-direction: column;\n    overflow: initial;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
